import fleetconnect from './fleetconnect'
import summitconnect from './summitconnect'
import elogbook from './elogbook'
import likemydrive from './likemydrive'
import base from './base'

const themes = {
    fleetconnect,
    summitconnect,
    elogbook,
    likemydrive,
}

export default function getTheme(theme, mode) {
    var t = (!!themes[theme]) ? themes[theme] : base
    t.palette.mode = mode
    return t
}
